import appLocaleData from "react-intl/locale-data/zh";
import zhMessages from "../locales/zh-ZH";

const ChLang = {
  messages: {
    ...zhMessages,
  },
  locale: "zh-ZH",
  data: appLocaleData,
};
export default ChLang;
